'use client';

import { useAuth } from '@svenskaspelab/nova-core/nextjs/auth';
import { showSnackbar, Snackbar } from '@svenskaspelab/ui/react/snackbar';
import { useSearchParams } from 'next/navigation.js';
import { useCallback, useEffect } from 'react';

import { dayTimeLimitEndDialog } from '../../../../lib/message-producers/day-time-limit/dialogs/dialogs.js';
import type { ShowDialogFn } from '../../types.js';
import SnackbarText from './components/snackbar-text/SnackbarText.js';
import useDayTimeLimit from './hooks/use-day-time-limit.js';

export default function DayTimeLimit({ showDialog }: { showDialog: ShowDialogFn }) {
  const params = useSearchParams();
  const { logout, isLoading } = useAuth();
  const returnUrl = params.get('returnUrl') || '/';

  const showEndMessage = useCallback(() => {
    void showDialog(
      dayTimeLimitEndDialog(
        () => {},
        () => {
          void logout({ returnUrl });
        }
      )
    );
  }, [showDialog, logout, returnUrl]);

  const showSoonEndSnackbar = useCallback((minutes = 5) => {
    showSnackbar({
      text: <SnackbarText minutes={minutes} />,
      showCloseButton: true,
    });
  }, []);

  const { init, isFetched } = useDayTimeLimit();

  useEffect(() => {
    if (isFetched && isLoading === false) {
      init({ showSoonEndMessage: showSoonEndSnackbar, showEndMessage });
    }
  }, [init, isFetched, isLoading, showSoonEndSnackbar, showEndMessage]);

  return <Snackbar />;
}
